module.exports = __webpack_public_path__ + "static/help-center-79400269c5ef87cc1b523a1628317302.svg";